import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthForm from '../components/AuthForm';
import { signup } from '../api/auth';

export default function SignUp() {
  const [errorMessage, setErrorMessage] = useState('')
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    try {
      if (e.username && e.password) {
        await signup(e.username, e.password)
        navigate('/auth/signin');
      }else if (!e.username) {
        setErrorMessage("Enter a username")
        return
      } else if (!e.password) {
        setErrorMessage("Enter a password")
        return
      }
    } catch(error) {
      setErrorMessage("Error Occured")
    }
  };

  return (
    <div className="flex flex-col items-center justify-center max-w-6xl px-4 py-20  bg-white bg-opacity-80 px-4 py-2 rounded-md">
      <h1 className="text-3xl font-orbit font-bold mb-6 text-purple">Sign Up</h1>
      <AuthForm onSubmit={handleSubmit} buttonText="SIGN UP" />
      <span className="mt-4">
        Already on <span className="font-orbit">Curb</span><span className="font-orbit font-bold">IT</span> ?<Link to="/auth/signin" className="text-purple  hover:text-bubble-gum font-semibold">Sign In</Link> instead.
      </span>
      <p className='mt-4 text-red font-bold'>{errorMessage}</p>
    </div>
  );
}
